export const ridersByNameWithOnlyBasicDetails = /* GraphQL */ `
    query RidersByName(
        $name: String!
        $createdOn: ModelStringKeyConditionInput
        $sortDirection: ModelSortDirection
        $filter: ModelRiderFilterInput
        $limit: Int
        $nextToken: String
    ) {
        ridersByName(name: $name, createdOn: $createdOn, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
            items {
                id
                name
                location
                address {
                    city
                    provState
                }
                birthdate
                isProfessional
                barnName
                barnId
                barn {
                    name
                }
            }
            nextToken
        }
    }
`;
